import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import useTrackCLK from "./useTrackCLK";

const PV_CONFIG: Record<string, string> = {
  "/login": "login_pv",
  "/home": "home_pv",
  "/chat": "chat_pv",
  "/fileChat": "doc_chat_pv",
  "/fileUpload": "doc_upload_pv",
};

const useTrackPV = () => {
  const { pathname } = useLocation();
  const { sendCLK } = useTrackCLK();

  useEffect(() => {
    sendPV(pathname);
    console.log("Route wrapper", pathname);
  }, [pathname]);

  const sendPV = (pathname: string) => {
    try {
      const key = PV_CONFIG[pathname];
      if (!!key) {
        sendCLK(key);
      }
    } catch (error) {
      console.log("sendPV error: ", error);
    }
  };
};

export default useTrackPV;
